import * as React from 'react';

import { PriceStore } from '../stores/PriceStore';

interface PriceProps {
    value?: number;
    currency?: string;
}

export class Price extends React.PureComponent<PriceProps> {
    public render(): JSX.Element | null {
        if (this.props.value == null || this.props.currency == null || !PriceStore.isCurrencyValid(this.props.currency)) {
            return <div className="price"/>;
        }
        return (
            <div className="price">{PriceStore.getPriceString(this.props.value, this.props.currency)}</div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Price.tsx